import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import rehypeRaw from "rehype-raw";
import remarkMath from 'remark-math'
import { HiOutlineUserCircle, 
  HiOutlineBriefcase, HiOutlineChip, 
  HiOutlineSearch } from "react-icons/hi";

const agentIconMapping = {
  "Main Agent": HiOutlineUserCircle,
  "Project Agent": HiOutlineBriefcase,
  "Simulation Agent": HiOutlineChip,
  "Research Agent": HiOutlineSearch,
};
function AgentIcon({ agentType, size = 24,classes }) {
  const IconComponent = agentIconMapping[agentType]
  return IconComponent ? <IconComponent title={agentType} className={classes} /> : null
}

function ChatMessage({ message,index }) {
  const { agentName = "",agent_name ='' } = message;
  let msg = message.text.replace('"',' ').replace('"','');
  let msgs = String(msg).replace(/\\n/g, "  \n").replace(/\\/g, "  \\");
  const CustomStrong = ({ children, ...props }) => (
    <strong className="dark:text-white text-gray-700" {...props}>
      {children}
    </strong>
  );
  const CustomH2 = ({ children, ...props }) => (
    <h3 className="dark:text-white text-gray-700" {...props}>
      {children}
    </h3>
  );
  const CustomH3 = ({ children, ...props }) => (
    <h3 className="dark:text-white text-gray-700" {...props}>
      {children}
    </h3>
  );
  const CustomH4 = ({ children, ...props }) => (
    <h4 className="dark:text-white text-gray-700" {...props}>
      {children}
    </h4>
  );
  
  const content = message.is_bot ? (
    <ReactMarkdown 
      components={{ strong: CustomStrong, h3:CustomH3,h4:CustomH4,h2:CustomH2 }}  
      rehypePlugins={[rehypeRaw]} 
      remarkPlugins={[remarkGfm]} 
      emarkPlugins={[remarkMath]} 
      children={msgs} 
    />
  ) : (
    <div className="whitespace-pre-wrap">{msg}</div>
  );

  if(message.is_bot){
    if(agentName || agent_name){
      return (<div key={index} className= {`flex min-w-0 w-full py-4  text-gray-400 text-sm max-w-none chat-message ${message.is_bot ? 'bot-message rounded-md' : 'user-message dark:!bg-gray-700 !bg-gray-300 '}`}>
          <AgentIcon agentType={agent_name|| agentName} classes="mr-1 px-1 max-h-[28px] min-h-[28px] min-w-[28px] max-w-[100px] border rounded-full cursor-pointer" />
          <div className="dark:text-white/60 px-2  text-gray-500 text-base font-normal font-['Inter'] leading-normal dark:bg-gray-700 bg-gray-300 flex flex-col gap-2 p-2 rounded-lg">
              <div className="flex text-xs"><span>{agent_name|| agentName}</span><span className="ml-auto">AI Agent</span></div>
              <p>{content}</p>
          </div>
        </div>
      )
    }
    return (<div key={index} className= {`flex min-w-0 w-full py-4  text-gray-400 text-sm max-w-none chat-message ${message.is_bot ? 'bot-message rounded-md' : 'user-message dark:!bg-gray-700 !bg-gray-300 '}`}>
        <img src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/cadencelogo.webp" className="mr-1 h-6 w-6" alt=" Cadencepro Logo" /> 
          <div className="dark:text-white/60 px-2  text-gray-500 text-base font-normal font-['Inter'] leading-normal">
              {content}
          </div>
        </div>
      )
      
  }

  if(!message.is_bot){
      return (<div key={index} className= {`ml-auto flex min-w-0 !max-w-[80%] !py-0 text-gray-400 text-sm justify-end chat-message `}>
          <div className={`dark:text-white/60 px-2  text-gray-500 text-base py-2  rounded-2xl font-normal font-['Inter'] leading-normal bg-white ${message.is_bot ? 'bot-message dark:!bg-gray-700 !bg-gray-300' : 'user-message dark:!bg-gray-700 !bg-gray-300 '}`}>
            {content}
          </div>
      </div>
      )
  }
}

export default ChatMessage;